module.exports = __webpack_public_path__ + "static/media/about12025.eb4cd8b3.png";